import { Skeleton } from '@/_components';
import { CardContainer, ImageTextHeader } from '@/_containers';
import { PageHeaderContainer } from '@/_containers/headers/page/page-header-container';

export function HeaderLoading() {
  return (
    <CardContainer>
      <section className="flex items-center justify-between">
        <div className="text-c-card-muted text-xs font-semibold">
          <Skeleton className="mt-1 h-5 w-36" />
        </div>
      </section>

      <PageHeaderContainer className="mt-4 mb-6">
        <ImageTextHeader
          imageSlot={<Skeleton className="size-28" />}
          primarySlot={<Skeleton className="mt-2 h-7 w-44" />}
          secondarySlot={<Skeleton className="mt-1 h-5 w-36" />}
        />
      </PageHeaderContainer>
    </CardContainer>
  );
}
